/*
 * Copyright (c) 2021, 2022 Tropyc Stoic (38c316a1b8d7188d059c273d892b723b)
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
import { useOutletContext } from "react-router-dom";
import Airdrop from '../Airdrop.js';

export default function AirdropPage() {
  const [web3, , , , , , , , airdrop] = useOutletContext();

  return (
    <>
      <h2>Airdrop</h2>

      <p className="lead">
      Use this handy util to airdrop at once to multiple addresses.
      </p>
        <Airdrop web3={web3} airdrop={airdrop} />
    </>
  );
}